import { SpaceCardProps } from '../../types/space-card.types';
import { CardImage } from '../space-card/CardImage';
import { CardContent } from '../space-card/CardContent';
import { CardActions } from '../space-card/CardActions';

export function SpaceCard({
  space,
  onEdit,
  onToggle,
  onDuplicate,
  onDelete,
  actionInProgress,
}: SpaceCardProps) {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        background: 'white',
        borderRadius: '16px',
        overflow: 'hidden',
        boxShadow: '0 4px 24px rgba(0,48,60,0.06)',
        border: '2px solid transparent',
        transition: 'all 0.3s ease',
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.borderColor = '#00758d';
        e.currentTarget.style.transform = 'translateY(-4px)';
        e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,117,141,0.12)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.borderColor = 'transparent';
        e.currentTarget.style.transform = 'translateY(0)';
        e.currentTarget.style.boxShadow = '0 4px 24px rgba(0,48,60,0.06)';
      }}
    >
      <CardImage space={space} onEdit={onEdit} />
      
      <div style={{ padding: '1.5rem', flex: 1, display: 'flex', flexDirection: 'column' }}>
        <CardContent space={space} onEdit={onEdit} />
        
        <CardActions
          space={space}
          onEdit={onEdit}
          onToggle={onToggle}
          onDuplicate={onDuplicate}
          onDelete={onDelete}
          actionInProgress={actionInProgress}
        />
      </div>
    </div>
  );
}
